/**
 * @fileOverview This file contains the implementation of the AgendaFooter component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Box, Typography } from "@mui/material";
import { GridFooter } from "@mui/x-data-grid-pro";
//#endregion

const AgendaFooter = ({ getStatusColor }) => {
  const statusList = [2, 3, 4, 5, 0, 6];
  return (
    <Box display={"flex"} justifyContent={"space-between"} sx={{ backgroundColor: "transparent" }}>
      
      <Box display={"flex"} >
        {statusList.map((status) => {
          const { color, name } = getStatusColor(status);
          return (
            <Box
              key={status}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
                marginRight: "1rem",
              }}
            >
              <Box
                sx={{
                  width: "1rem",
                  height: "1rem",
                  backgroundColor: color,
                  borderColor: "black",
                  borderStyle: "solid",
                  borderWidth: "0.1rem",
                }}
              />
              <Typography variant="body1">{name}</Typography>
            </Box>
          );
        })}
      </Box>
      <Box>
        <GridFooter sx={{ border: 'none' }}/>
      </Box>
    </Box>
  );
};

export default AgendaFooter;
